import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Verified from 'feature/chatBot/verified';
import BotDemo from 'feature/chatBot/botDemo';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Route for the 'verified' view */}
        <Route path="/verified" element={<Verified onClose={() => window.history.back()} />} />

        {/* Route for the 'demo' view (default) */}
        <Route path="/demo" element={<BotDemo />} />
        <Route path="*" element={<Navigate to="/demo" />} />
      </Routes>
    </Router>
  );
};

export default App;
